import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { Submission } from '../models/submission';

type SliceModel = Submission;
const sliceName: string = 'submissions';

const currRequests: Set<ModelId> = new Set;

export const fetchSubmission = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const submissionAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id
});
export const submissionSlice = createSlice({
    name: sliceName,
    initialState: submissionAdapter.getInitialState(),
    reducers: {
        addMany: submissionAdapter.addMany,
        addOne: submissionAdapter.addOne,
        updateMany: submissionAdapter.updateMany,
        updateOne: submissionAdapter.updateOne,
        upsertOne: submissionAdapter.upsertOne,
        upsertMany: submissionAdapter.upsertMany,
        removeOne: submissionAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchSubmission.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                submissionAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
